import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import CheckmarkSvg from '../../../assets/icons/app/checkmark.svg?raw';

export const CheckmarkIcon = (props) => <CustomSVG svg={CheckmarkSvg} preserveColors appIconSmall {...props} />;
